import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = React.useState<number | null>(null);

  const faqs = [
    {
      question: "Como funciona o download automático de XMLs?",
      answer: "Nossa plataforma se conecta diretamente com as Secretarias da Fazenda e baixa automaticamente os XMLs de todas as suas notas fiscais, mantendo tudo organizado e atualizado."
    },
    {
      question: "A plataforma é compatível com meu ERP?",
      answer: "Sim, oferecemos APIs REST documentadas para integração com qualquer sistema. Também temos integrações prontas com os principais ERPs do mercado."
    },
    {
      question: "Quais tipos de notas fiscais são suportados?",
      answer: "Suportamos NF-e (Nota Fiscal Eletrônica), NFS-e (Nota Fiscal de Serviços) e NFC-e (Nota Fiscal do Consumidor), além de outros documentos fiscais."
    },
    {
      question: "Como é feito o suporte técnico?",
      answer: "Oferecemos suporte técnico especializado por chat, email e telefone em horário comercial, com tempo médio de resposta de 15 minutos."
    },
    {
      question: "Os dados são seguros?",
      answer: "Sim, utilizamos criptografia de ponta a ponta e mantemos backups automáticos. Nossa infraestrutura segue as melhores práticas de segurança do mercado."
    },
    {
      question: "Preciso instalar algum software?",
      answer: "Não, nossa solução é 100% web e funciona em qualquer navegador. Você só precisa de acesso à internet para utilizar todas as funcionalidades."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#103541] mb-4">
            Dúvidas Frequentes
          </h2>
          <p className="text-[#2E6173] text-lg">
            Encontre respostas para as principais dúvidas sobre nossa solução
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-gray-200 rounded-xl overflow-hidden"
            >
              <button
                className="w-full px-6 py-4 text-left bg-white hover:bg-gray-50 flex items-center justify-between"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-semibold text-[#103541]">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="text-[#7AEA53]" />
                ) : (
                  <ChevronDown className="text-[#2E6173]" />
                )}
              </button>
              
              {openIndex === index && (
                <div className="px-6 py-4 bg-gray-50 text-[#2E6173]">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;